export const ActionTypes = 
{
    LOGIN : "LOGIN",
    LOGOUT : "LOGOUT",
    SET_SESSION_TIMEOUT : "SET_SESSION_TIMEOUT"
}